import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { IProduct } from 'modules/inventory/product/interfaces/IProduct';
import {
  AssignComboStockPayload,
  ComboAvailability,
  UpdateComboPayload,
} from 'modules/inventory/product/interfaces/ICombo';

class ComboService extends EntityApiService<IProduct> {
  updateCombo = (productId: string, payload: UpdateComboPayload, config?: RequestConfig): Promise<any> => {
    return this.handleResponse(ApiClientService.patch(this.getPath(`/${productId}/combo`), payload, config));
  };

  getAvailability = (productId: string, config?: RequestConfig): Promise<ComboAvailability[]> => {
    return this.handleResponse(ApiClientService.get(this.getPath(`/${productId}/combo/availability`), config));
  };

  assignStock = (productId: string, payload: AssignComboStockPayload, config?: RequestConfig): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${productId}/combo/stock`), payload, config));
  };
}

export default new ComboService('/ms-inventory/api/products');
